export default {
    "profile": "Perfil",
    "logout": "Sair",
    "dashboard": "Painel",
    "password": "Senha",
    "language": "Linguagem",
    "paymentbr": "Pagamento",
    "subscriptionPaymentMethod": "Assinatura e Método de Pagamento",
    "nothingchanged": "Nada mudou",
    "somethingWentWrong": "Algo deu errado! Por favor, tente novamente mais tarde",
    "pleaseTryAgainAfterSometime": "Por favor, tente novamente depois de algum tempo",
    "noChanges": "Não mudou",
    "invalidEmailFormat": "O formato do e-mail é inválido",
    "chooseYourPreferredLanguage": "Por favor, escolha seu idioma preferido.",
    "selectLanguage": "Selecione o idioma",
    "update": "Atualizar",
    "languagePreferences": "Preferências de idioma",
    "packageOf": "Pacote de",
    "satelliteReport": "relatórios de satélite",
    "pastureReport": "relatórios de pasto",
    "upTo": "Até",
    "animals": "animais",
    "back": "Voltar",
    "perMonth": "Por mês",
    "perYear": "Por ano",
    "continue": "Continuar",
    "changePlan": "Alterar Plano",
    "addOn": "Adicionar",
    "totalPrice": "Preço total",
    "availableAddOns": "Complementos disponíveis",
    "next": "Próximo",
    "congratulations": "Parabéns",
    "done": "FEITO",
    "deforestationComplianceAssessment": "Avaliações de conformidade de desmatamento",
    "warning": "Aviso",
    "yourDataMightLost": "Seus dados podem ser perdidos.",
    "clickOnSaveBtnMsg": "Clique no botão salvar para preservar seus dados",
    "discardChanges": "Descartar mudanças",
    "action": "Ações",
    "sendRequest": "Enviar pedido",
    "success": "Sucesso",
    "yourRequestSuccessfullySubmitted": "Sua solicitação foi enviada com sucesso.",
    "informShortly": "Seu pedido foi enviado com sucesso. Seu relatório de análise será enviado a você em breve.",
    "search": "Procurar",
    "pending": "Pendente",
    "approved": "Aprovado",
    "rejected": "Rejeitado",
    "primaryGeofence": "Cerca geográfica primária",
    "Zero/Negligible Deforestation Probability": "Probabilidade de Desmatamento Zero/Negligível",
    "Low Deforestation Probability": "Baixa Probabilidade de Desmatamento",
    "High Deforestation Probability": "Alta Probabilidade de Desmatamento",
    "login": {
        "welcome": "Bem-vindo! Conecte-se",
        "welInfo": "Insira suas credenciais.",
        "login": "Conecte-se",
        "emailMobile": "E-mail/Celular",
        "forgotPassword": "Esqueceu sua senha",
        "register": "Registro",
        "unableToLogin": "Incapaz de entrar",
        "emailMobileCannotEmpty": "Email/Celular não pode ficar vazio.",
        "invalidEmailMobileFormat": "Formato de e-mail/celular inválido.",
        "passwordCannotEmpty": "A senha não pode estar vazia.",
        "passwordLengthCanlessthan8": "O comprimento da senha não pode ser inferior a 8 caracteres.",
        "email": "E-mail",
        "phone": "Telefone",
        "or": "OU",
        "alreadyHaveAccount": "Já tem uma conta",
        "loginNow": "Conecte-se agora",
        "registerOption": "Escolha uma opção para se inscrever",
        "signUpWith": "Inscreva-se com"
    },
    "user": {
        "profileUpdated": "O perfil foi atualizado com sucesso",
        "profileNotUpdated": "O perfil não foi atualizado",
        "otpSentOnEmail": "OTP foi enviado com sucesso!",
        "otpSentSuccessFully": "Seu código OTP foi enviado",
        "unableToVerifyEmail": "Não foi possível verificar o e-mail",
        "emailCanNotBeEmpty": "Os campos de e-mail não podem ficar vazios",
        "firstName": "Primeiro nome",
        "lastName": "Sobrenome",
        "email": "E-mail",
        "mobile": "Móvel",
        "currentPassword": "Senha atual",
        "newPassword": "Nova Senha",
        "repeatNewPassword": "Repita a nova senha",
        "firstNameRequired": "O primeiro nome é necessário.",
        "lastNameRequired": "O sobrenome é obrigatório",
        "emailRequired": "O e-mail é obrigatório",
        "onlyAlphabet": "Só pode conter alfabetos",
        "notMoreThan15Char": "Não pode ter mais de 15 caracteres",
        "phoneCannotLessThan8Char": "O telefone não pode ter menos de 8 caracteres",
        "countryCodeRequire": "O código do país é obrigatório",
        "changePassword": "Alterar a senha",
        "goodIdeaToUsePassword": "É uma boa ideia usar uma senha forte que você não esteja usando em outro lugar.",
        "enterCurrentPassword": "Digite a senha atual",
        "enterNewPassword": "Insira a nova senha",
        "reEnterPassword": "Digite novamente a senha",
        "pleaseTypeOldPassword": "Por favor digite a senha antiga.",
        "pleaseTypeNewPassword": "Por favor digite a nova senha.",
        "pleaseTypeConfirmPassword": "Por favor digite confirmar senha.",
        "passwordChangedSuccesFully": "Senha alterada com sucesso",
        "passwordDoesNotMatch": "As senhas não coincidem.",
        "passwordRequired": "Senha requerida",
        "emailOrPhoneIsRequired": "E-mail ou número de telefone é obrigatório"
    },
    "subscription": {
        "subscription": "Inscrição",
        "membershipPlan": "Planos de Sócios",
        "currentMembershipPlan": "Plano de associação atual",
        "validUpTo": "Válido até",
        "viewAllAddOns": "VER TODOS OS COMPLEMENTOS",
        "renewValidity": "Renovar Validade",
        "buyNow": "Comprar agora",
        "upgradeMembershipPlan": "Atualizar plano de associação",
        "chooseYourMembershipPlan": "Seu plano de associação escolhido",
        "chooseOptionalAddOns": "Você pode escolher complementos opcionais",
        "yourSelectedAddons": "Seus complementos selecionados",
        "addAnotherAddOn": "Adicionar outro complemento",
        "paymentMethod": "Forma de pagamento",
        "addingAPaymentMethod": "Adicionando um método de pagamento",
        "paymentSuccessful": "Seu pagamento foi aprovado!",
        "weHaveEmailed": "Enviamos uma cópia do seu recibo por e-mail para example@email.com",
        "paymentAuthorizedSuccessfully": "Pagamento autorizado com sucesso.",
        "paymentSuccessfulPrompt": "Pagamento bem-sucedido. Plano atualizado.",
        "paymentCancelled": "Pagamento cancelado. Por favor, tente novamente."
    },
    "registerFarm": "Cadastrar Fazenda",
    "requestDeforestationReport": "Solicitar Relatório de Desmatamento",
    "paymentMenu": "Pagamento",
    "complianceCertificate": "Certificado de conformidade",
    "helpDisk": "Disco de Ajuda",
    "faqs": "Perguntas frequentes",
    "enquiries": "Inquéritos",
    "contactUs": "Contate-nos",
    "payment": {
        "basicPlan": "Plano Básico",
        "advancePlan": "Plano Antecipado",
        "usdPerMonthPlus": "USD por mês mais",
        "perReport": "por relatório",
        "deforestationAnalyticsCertificateDownload": "Download do certificado de análise de desmatamento"
    },
    "farm": {
        "farmOwnershipType": "Tipo de propriedade agrícola",
        "licenceNum": "Número de licença",
        "viewFarm": "Ver Fazenda",
        "stateProvince": "Província/Estado",
        "postalNumberShouldSimilarToFarm": "O número postal da fazenda é semelhante ao número da casa.",
        "videoTutorial": "Vídeo tutorial",
        "clickOnMapMSG": "Clique no mapa para iniciar a cerca geográfica",
        "prev": "Anterior",
        "next": "Próximo",
        "dragVertexMsg": "Você também pode arrastar o vértice ou excluí-lo usando o botão Excluir no lado direito. A cerca geográfica também pode ser limpa usando o botão limpar",
        "farmAddedSuccessfully": "Fazenda adicionada com sucesso",
        "perimeter": "Perímetro",
        "area": "Área",
        "clearGeofence": "Limpar cerca geográfica",
        "deleteSelectedVertex": "Excluir vértice selecionado",
        "pleaseStartDrawing": "Por favor, comece a desenhar uma cerca geográfica no mapa.",
        "chooseTheDate": "Escolha a data",
        "updateGeofenceForThisFarm": "ATUALIZAR GEOFENCE para esta fazenda",
        "farmUpdateSuccessfully": "Fazenda atualizada com sucesso",
        "farmZone": "Zonas agrícolas",
        "addNewZones": "Adicionar novas zonas",
        "zoneName": "Nome da zona",
        "addZoneToCreate": "Clique em Adicionar Zonas para criar uma Zona para esta fazenda.",
        "noZoneCreated": "Nenhuma zona foi criada ainda.",
        "searchAndAddPin": "Pesquise e adicione um alfinete",
        "zoneNameWillBeHere": "O nome da zona estará aqui",
        "editZone": "Editar zona",
        "nameOfTheField": "Nome do campo",
        "zoneDetails": "Detalhes da zona",
        "addZone": "Adicionar zona",
        "nameOfTheZone": "Nome da zona",
        "geofenceIsRequiredToAdd": "A cerca geográfica é necessária para adicionar zona. Clique em `Editar fazenda` para adicionar detalhes da cerca geográfica à sua fazenda.",
        "thisFieldApplyHelpText": "Este campo aplica-se apenas a si se pertencer a qualquer cooperativa (uma cooperativa é uma associação autónoma de pessoas unidas voluntariamente para satisfazer as suas necessidades e aspirações económicas, sociais e culturais comuns através de uma empresa de propriedade conjunta e controlada democraticamente). SE pertence a uma cooperativa, indique o identificador único dessa cooperativa, que pode ser um número de registo ou de licença que identifique exclusivamente a cooperativa à qual se associa.",
        "farmRegistrationID": "ID de registro da fazenda",
        "farmerName": "Nome do Fazendeiro",
        "farmerRegistrationID": "ID de registro do agricultor",
        "dateOfRequest": "Data da solicitação",
        "status": "Status",
        "address": "Endereço",
        "save": "Salvar",
        "farmAddress": "Endereço de localização da fazenda",
        "corporateName": "Razão social",
        "corporateMailingAddress": "Endereço postal corporativo",
        "farmID": "ID da fazenda",
        "onTheFarm": "Na fazenda",
        "userRoles": "Funções do usuário",
        "adduser": "Adicionar usuário",
        "addAuser": "Adicionar um usuário",
        "uploadUsers": "Carregar usuários",
        "addNewUser": "Adicionar novo usuário",
        "selectDept": "Selecione Departamento",
        "selectRole": "Selecione a função",
        "editUser": "Editar usuário",
        "totalFarms": "Total de fazendas",
        "NoAnimalsRegisteredForthisFarm": "Nenhum animal está registrado para esta fazenda",
        "farmsPerPage": "Fazendas por página",
        "regularFarms": "Fazendas Regulares",
        "farmRegisteredProducts": "Produtos registrados na fazenda",
        "searchByFarmNameAndId": "Pesquise por nome e ID da fazenda",
        "loadingProductsPleaseWait": "Carregando Produtos... Aguarde",
        "farmName": "Nome da Fazenda",
        "farmLocation": "Localização da Fazenda",
        "productName": "Nome do Produto",
        "stockStatus": "Status do estoque",
        "inStock": "Em estoque",
        "searchByProductName": "Pesquisar por nome do produto",
        "productCategory": "Categoria de Produto",
        "products": "Produtos",
        "yourLocationIsDisabled": "Sua localização está desativada. Pesquise sua localização nos menus à esquerda.",
        "close": "Fechar",
        "farms": "Fazendas",
        "zones": "Zonas",
        "registerAfarm": "Cadastre uma fazenda",
        "govtRegistry": "Governo Registro",
        "cooperativeID": "ID Cooperativa/Sindical",
        "cooperativeName": "Nome da Cooperativa/Sindicato",
        "farmType": "Tipo de fazenda",
        "contractMating": "Acasalamento por contrato",
        "customization": "Costumização",
        "recordsPerpage": "Registros por página",
        "restoreDefault": "Restaurar padrão",
        "apply": "Aplicar",
        "CommunityName": "Nome da comunidade",
        "searchState": "Pesquise por ID da Fazenda, Registro Governamental, ID da Cooperativa, Tipo de Fazenda, Acasalamento por Contrato",
        "farmOwner": "Proprietário da Fazenda",
        "govRegistrationNo": "Número de registro governamental",
        "farmInformation": "Informações da fazenda",
        "ownershipType": "Tipo de propriedade",
        "farmLicenseInformation": "Informações sobre licença agrícola",
        "licenseNumber": "Número de licença",
        "licenseExpiryDate": "Data de expiração da licença",
        "regulatorName": "Nome do Regulador",
        "regulatorRepresentativeName": "Nome do Representante do Regulador",
        "farmLocationSize": "Localização e tamanho da fazenda",
        "productionSystem": "Sistema Agrícola",
        "country": "País",
        "state": "Estado",
        "city": "Aldeia/Vila/Cidade",
        "farmNumber": "Número da fazenda",
        "postal": "Código postal",
        "houseNumber": "Número da casa",
        "farmRegistration": "Cadastro de Fazenda",
        "cancel": "Cancelar",
        "register": "Registro",
        "ok": "OK",
        "totalFarmSize": "Tamanho total da fazenda",
        "geographicLocation": "Localização geográfica",
        "farmGeographicLocation": "Localização geográfica da fazenda",
        "perimeterPointLongitude": "Longitude do ponto do perímetro",
        "perimeterPointLatitude": "Latitude do ponto do perímetro",
        "perimeterPointLabel": "Etiqueta de ponto de perímetro",
        "perimeterLength": "Comprimento do perímetro",
        "farmLatitude": "Latitude da Fazenda",
        "farmLongitude": "Longitude da Fazenda",
        "latitude": "Latitude",
        "longitude": "Longitude",
        "areaUnit": "Unidade de área",
        "walkAndMeasure": "ANDAR E MEDIR",
        "useGeofenceTool": "USE A FERRAMENTA GEOFENCE",
        "editFarm": "Editar Fazenda",
        "update": "Atualizar",
        "editAfarm": "Editar uma fazenda",
        "nextFarm": "Próxima Fazenda",
        "nameoftheFarm": "Nome da Fazenda",
        "registerAProduct": " Registre um produto",
        "farmProducts": "Produtos agrícolas",
        "calf": "Panturrilha",
        "steer": "Dirigir",
        "heifer": "Novilha",
        "sire": "Pai",
        "dam": "Barragem",
        "registerAnAnimal": "Registre um animal",
        "farmAnimals": "Animais de fazenda",
        "farm_type": "Tipo fazenda",
        "farm_Owner": "Proprietário da Fazenda",
        "dateOfRegistration": "Data de registro",
        "dataIsNotAvailableForThisFarm": "Os dados não estão disponíveis para esta fazenda",
        "registerNewProduct": "Registre um novo produto",
        "information": "Informação",
        "licenseInfo": "Informações sobre licença",
        "locationInfo": "Informações de localização",
        "geoLocation": "Localização geográfica",
        "perimeterLengthState": "Comprimento do perímetro das fazendas (comprimento da cerca)",
        "totalFarmSizeState": "Tamanho de uma fazenda",
        "productionSystemState": "Sistema de Produção utilizado na Fazenda",
        "contractMatingState": "Código do Programa de Acasalamento Contratual do qual a Fazenda Participa.",
        "ownershipTypeState": "Tipo de propriedade",
        "regulatorRepresentativeNameState": "Nome da pessoa que representa o regulador que liberou a licença",
        "regulatorNameState": "Nome do regulador que liberou a licença",
        "licenseExpiryDateState": "Data em que a licença atual expirou",
        "licenseNumberState": "Número de licença divulgado pelo regulador",
        "plotNumberState": "Número da casa da fazenda.",
        "plotNumber": "Número da fazenda",
        "streetStatement": "Nome da rua da fazenda.",
        "cityStatement": "Cidade onde está localizada a fazenda.",
        "stateStatement": "Região do país onde a fazenda está localizada.",
        "countryState": "País onde a fazenda está localizada.",
        "farmStateInfo": "Endereço de localização da fazenda",
        "perimeterPointLongitudeState": "Longitude de um ponto na fazenda.",
        "perimeterPointLatitudeState": "Latitude de um ponto na fazenda.",
        "perimeterPointLabelState": "Etiqueta do ponto.",
        "farmLongitudeState": "Longitude da fazenda.",
        "farmLatitudeState": "Latitude da fazenda.",
        "deleteFarm": "Excluir fazenda",
        "corporateRegistrationNum": "Número de registro corporativo",
        "farmLocationIsRequired": "A localização da fazenda é obrigatória."
    },
    "deforestation": {
        "addZoneToThisFarm": "Adicionar zonas a este farm",
        "eudrForestAssessment": "Avaliações Florestais EUDR",
        "requestEudrForestAssessment": "SOLICITAR AVALIAÇÃO FLORESTAL EUDR",
        "pleaseChooseOption": "Escolha a opção",
        "requestForestReport": "Solicitar Relatório Florestal",
        "noDeforestationReportMsg": "Nenhum relatório de desmatamento foi solicitado. Solicite alguns relatórios de desmatamento para listá-los aqui.",
        "allCountries": "Todos os países",
        "allRegions": "Todas as regiões",
        "allFarms": "Todas as fazendas",
        "allStatus": "Todos os status",
        "viewCertificate": "Ver certificado",
        "requestComplianceCertificate": "SOLICITAR CERTIFICADO DE CONFORMIDADE",
        "assessmentNo": "Avaliação Não",
        "blockchainCertificationInfo": "O hash de validação do certificado Blockchain estará disponível após a aceitação do certificado",
        "blockchainCertificationValidation": "Validação de Certificado Blockchain",
        "openBlockchainPage": "Abrir página Blockchain",
        "clickOnAboveLink": "Clique no link acima para validar o certificado no blockchain",
        "shareCertificate": "Compartilhar certificado",
        "high": "Alto",
        "low": "Baixo",
        "zeroOrNegigible": "Zero ou Negigível",
        "deforestationProbability": "Probabilidade de desmatamento",
        "colorCode": "Código de cores",
        "geofenceAarea": "Área de cerca geográfica",
        "percentageOfGeofenceArea": "Porcentagem da área da cerca geográfica",
        "overallDeforestationProbability": "Probabilidade geral de desmatamento",
        "deforestationComplianceReport": "Relatórios de conformidade de desmatamento",
        "noDeforestationComplianceReport": "Nenhum relatório eletrônico de conformidade com desmatamento encontrado",
        "loadingDeforestationComplianceReport": "Carregando Relatório Eletrônico de Conformidade com Desmatamento",
        "farmRegistrationId": "ID de registro da fazenda",
        "farmerName": "Nome do Fazendeiro",
        "farmerRegistrationId": "ID de registro do agricultor",
        "uniqueFarmerId": "ID exclusiva do fazendeiro",
        "uniqueFarmId": "ID exclusivo da fazenda",
        "farmLocation": "Localização da Fazenda",
        "area": "Área",
        "farmAddress": "Endereço da Fazenda",
        "dateOfRequest": "Data da solicitação",
        "status": "Status",
        "settings": "Configurações",
        "assignmentIssued": "Atribuição emitida",
        "certificateIssued": "Certificado emitido",
        "complianceCertification": "Certificação de Conformidade",
        "noComplianceCertification": "Nenhuma certificação de conformidade encontrada",
        "loadingComplianceCertification": "Carregando Certificação de Conformidade",
        "assessmentReport": "Relatório de avaliação",
        "downloadPDF": "baixar PDF",
        "print": "Imprimir",
        "back": "Voltar",
        "farmDetails": "Detalhes da Fazenda",
        "dimitraFarmId": "ID da Fazenda Dimitra",
        "dimitraFermerId": "ID do fazendeiro Dimitra",
        "totalGeofenceAreaHA": "Área total da cerca geográfica (HA)",
        "forestLossHA": "Perda Florestal (HA)",
        "forestGainHA": "Ganho Florestal (HA)",
        "forestUnchangedHA": "Floresta Inalterada (HA)",
        "forestUnchanged": "Floresta Inalterada",
        "forestLoss": "Perda Florestal",
        "forestGain": "Ganho Florestal",
        "totalGeofenceArea": "Área total da cerca geográfica",
        "forestAssessmentHelp": "Se você tiver dúvidas sobre este relatório ou precisar de ajuda para entendê-lo, entre em contato conosco através do Help Desk.",
        "allReport": "Todos os relatórios",
        "deforestationRepot": "Relatórios de desmatamento",
        "requestDeforestationReportNow": "SOLICITE RELATÓRIO DE DESMATAMENTO AGORA",
        "noRecordFound": "Nenhum Registro Encontrado",
        "noDeforestationReportRequested": "Nenhum relatório de desmatamento foi solicitado. Solicite alguns relatórios de desmatamento para listá-los aqui.",
        "deforestationImage": "Imagem de desmatamento",
        "reqDeforestationReport": "Solicitar Relatório de Desmatamento",
        "confirm": "confirme",
        "newForestArea": "Nova Área Florestal",
        "deforestedArea": "Área Desmatada",
        "existingForestArea": "Área Florestal Existente",
        "deforestation": "Desmatamento",
        "farmName": "Nome da Fazenda",
        "location": "Localização",
        "dateOfInterest": "Data de interesse",
        "geofenceArea": "Área de cerca geográfica (HA)",
        "deforestationArea": "Área de Desmatamento (HA)",
        "treeGainArea": "Área de ganho de árvores (HA)",
        "currentForestArea": "Área Florestal Atual (HA)",
        "view": "Visualizar",
        "locationInfoRequired": "As informações de localização são obrigatórias",
        "geofenceNameRequired": "O nome da cerca geográfica é obrigatório",
        "futureDateSelected": "Data futura selecionada",
        "reportGeneratedSuccessfully": "Relatório gerado com sucesso",
        "reportCannotAdded": "O relatório não pode ser adicionado.",
        "primaryFarmNotFound": "Farm primário não encontrado.",
        "pleaseRegisterFarmFirst": "Por favor, registre a fazenda primeiro"
    },
    "certificate": {
        "allCertificate": "Todos os certificados",
        "certificate": "Certificado"
    }
}